import {
    Box,
    Paper,
    Skeleton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from '@mui/material'

export const FareRuleSkeleton = () => {
    return (
        <Box
            sx={{
                p: { md: 2 },
                pt: { xs: 2, md: 0 }
            }}
        >
            <Typography variant="body1" fontWeight={700} sx={{ mb: 2, textAlign: 'start' }}>
                Base Fare (Per Traveler)
            </Typography>

            <TableContainer
                component={Paper}
                sx={{
                    border: '1px solid #E0E0E0',
                    borderRadius: 2,
                    overflow: 'hidden',
                    boxShadow: 'none'
                }}
            >
                <Table>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: '#F9FAFB' }}>
                            <TableCell sx={{ fontWeight: 600, borderRight: '1px solid #E0E0E0' }}>
                                <Skeleton width="140px" />
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600, borderRight: '1px solid #E0E0E0' }}>
                                <Skeleton width="80px" />
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>
                                <Skeleton width="80px" />
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {[...Array(2)].map((_, idx) => (
                            <TableRow key={idx}>
                                <TableCell sx={{ borderRight: '1px solid #E0E0E0' }}>
                                    <Skeleton width="100px" />
                                </TableCell>
                                <TableCell sx={{ borderRight: '1px solid #E0E0E0' }}>
                                    <Skeleton width="60px" />
                                </TableCell>
                                <TableCell>
                                    <Skeleton width="60px" />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Paper
                sx={{
                    p: 1.5,
                    mt: 2,
                    backgroundColor: '#F9FAFB',
                    boxShadow: 'none',
                    borderRadius: 2
                }}
            >
                <Skeleton width="90%" height={14} sx={{ mb: 1 }} />
                <Skeleton width="80%" height={14} sx={{ mb: 1 }} />
            </Paper>
        </Box>
    )
}
